<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("offertypes") }}</div>
      <router-link class="btn-blue" to="add-offer-Types">{{
        $t("add")
      }}</router-link>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          :onSelect="filterIsActive => getOfferList(filterIsActive)"
        />
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;{{ $t("of") }}&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>
    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th>
              <img
                v-if="this.columnName != 'mkt_title'"
                @click="onSortValue('mkt_title', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('mkt_title', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('mkt_title', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("marketingtype") }}
            </th>
            <th>
              <img
                v-if="this.columnName != 'ot_offer_type'"
                @click="onSortValue('ot_offer_type', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('ot_offer_type', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('ot_offer_type', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("offer") }}
            </th>
            <th class="text-right">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
          </tr>
        </thead>
        <tbody v-if="offername.length > 0">
          <tr v-for="(offer, offerIndex) in offername" :key="offerIndex">
            <td>{{ offer.mkt_title }}</td>
            <td>{{ offer.ot_offer_type }}</td>
            <td>
              <div class="d-flex align-items-center justify-content-end">
                <!-- <label class="ios-switch">
                  <input
                    :checked="offer.ot_is_active == 'Y'"
                    disabled
                    type="checkbox"
                    class="ios-checkbox"
                  />
                  <span class="switch-slider"></span>
                </label> -->
                <StatusDot
                  :status="
                    offer.ot_is_active === 'Y'
                      ? 'active'
                      : offer.ot_is_active === 'N' && 'inactive'
                  "
                />
                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item v-on:click="onEditOffer(offer)">
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item v-on:click="onViewOffer(offer)">
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="3">
              <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination
        v-if="offername.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown
  },
  data() {
    return {
      ot_id: "",
      ot_offer_type: "",
      marketing_type_id: "",
      mkt_id: "",
      mkt_title: "",
      offername: [],
      // institutes: [],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ],

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: ""
    };
  },
  beforeMount() {
    this.getOfferList();
    // this.onViewOffer();
    // this.onEditInstitute();
  },
  methods: {
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getOfferList();
    },
    getOfferList: function(filterIsActive = "Y") {
      this.offername = [];
      MarketingService.getAllOfferType(
        this.perPage,
        this.currentPage,
        this.columnName,
        this.orderby,
        filterIsActive
      ).then(response => {
        // console.log("response :", response);
        const { data } = response;

        // console.log("data.Records :", data.Records);
        if (data && data.Records.length > 0) {
          this.offername = data.Records;
          // console.log("this.offername :", this.offername);
          this.rows = data.totalCount;

          if (this.rows <= this.selectedvalue) {
            // this.selectedvalue = this.rows;
          }
        }
      });
    },
    onViewOffer: function(offer) {
      this.$router.push({
        path: "/marketing/view-offer-Types",
        query: { ot_id: offer.ot_id }
      });
      // console.log("institute_id ++++++++ :", offer);
    },
    onEditOffer: function(offer) {
      this.$router.push({
        path: "/marketing/edit-offer-Types",
        query: { ot_id: offer.ot_id }
      });
      // console.log("bank_id :", bank.bank_id);
    },

    onChangePagination: function(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getOfferList();
      } else {
        this.currentPage = event;
        this.getOfferList();
      }
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        // console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        // console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/OfferComponents/offerTypes.vue